import { action, orchestrator } from 'satcheljs';
import { setIsSaving } from 'owa-options-store';
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';

export const saveOptions = action('saveOptions');

orchestrator(saveOptions, async () => {
    try {
        setIsSaving(true);
        await saveOrDiscardOptions(true);
    } finally {
        setIsSaving(false);
    }
});
